import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
// ajax请求链接
import urls from 'libs/urls.js'
// ajax请求方法
import axios from 'libs/http.js'

import { getQueryStringByName, getUrlParam } from 'libs/common/common.js'

import add from './modules/add.js'
import meal from './modules/setMeal.js'

Vue.use(Vuex)
const initPageState = () => {
    return {
        // 控制是否显示底部导航
        isShowBottomTab: true,
        // 高亮底部导航
        tabActive: '',
        // code值
        code: '',
        // token值 //本地开发调试 30天会过期
        // token: 'a3d4108a062c076d75c04afaa9603ddd',
        token: '',
        // 用户身份信息
        userInfo: {
            account: '', // "XUSHENG1",
            aid: '', // 18411, //地区id
            area: '', // "A_长沙", 地区名
            id: '', // "OCxusheng1", 用户id
            level: '', // 等级 ，0 是省，1 是市，2 是区或者分公司
            phone: '', // "13873110056",
            pid: '', // 0, 上级id
            username: '', // "徐胜", 用户名
        },
        // 用户个人所在地区信息，及下面的地区
        areaDatas: {
            children: [],
            id: '',
            level: '',
            name: "",
            pid: '',
        }
    }
}
const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        add,
        meal
    },
    state: initPageState(),
    mutations: {
        [types.SET_PAGE_STATE_ROOT](state, pageState) {
            for (const prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_TOKEN](state, pageState) {
            for (const prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_USER](state, pageState) {
            for (const prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_CODE](state, pageState) {
            for (const prop in pageState) {
                state[prop] = pageState[prop]
            }
        },

        [types.SAVE_USER_AREAS](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
    },
    actions: {
        [types.GET_TOKEN](context) {
            console.log('this', this.state)
            console.log('urls.getToken', urls.getToken)
            axios.post(urls.getToken, {
                    code: this.state.code
                })
                .then((res) => {
                    console.log('res.token:', res.data)
                    if (res.data.code === 200) {
                        context.commit('SAVE_TOKEN', {
                                token: res.data.data.token
                            })
                            // alert(res.data.data.token)
                        axios.interceptors.request.use(
                            config => {
                                // 判断是否存在token，如果存在的话，则每个http header都加上token
                                config.headers['Access-Token'] = this.state.token;
                                return config;
                            },
                            err => {
                                return Promise.reject(err);
                            });

                        this.dispatch('GET_USER')
                    } else {
                        // alert(res.data.message)
                    }
                })
                .catch(error => {
                    alert('token获取失败')
                    console.log(error);
                });
        },
        [types.GET_USER](context) {

            axios.interceptors.request.use(
                config => {
                    // 判断是否存在token，如果存在的话，则每个http header都加上token
                    config.headers['Access-Token'] = this.state.token;
                    return config;
                },
                err => {
                    return Promise.reject(err);
                });

            axios.get(urls.getUser)
                .then((res) => {
                    // console.log('res.userInfo1:', res.data)
                    if (res.data.code === 200) {
                        context.commit('SAVE_USER', {
                                userInfo: res.data.data
                            })
                            // alert(res.data.data.aid)
                            // console.log('this.state.userInfo:', this.state.userInfo)
                    } else {
                        alert(res.data.message)
                    }
                })
                .catch(error => {
                    alert('token无效，用户信息获取失败')
                    console.log(error);
                });
        },
        // 用户个人所在地区信息，及下面的地区
        [types.EGT_USER_AREAS](context, params) {
            return new Promise((resolve, reject) => {
                axios.get(urls.areaList)
                    .then((res) => {
                        resolve(res)
                        if (res.data.code === 200) {
                            context.commit('SAVE_USER_AREAS', {
                                areaDatas: res.data.data
                            })
                        } else {
                            // alert(res.data.message)
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/app/index.js